export function getMimeType(val: string) {
    var mimeType = val.match(/[^:/]\w+(?=;|,)/)[0];
    //var mimeType = val.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];
    return mimeType;
} 

export const BASE64_PREFIX: string = "data:image/png;base64,"